import { render, staticRenderFns } from "./FieldSelectorMultiple.vue?vue&type=template&id=2736c876&scoped=true"
import script from "./FieldSelectorMultiple.vue?vue&type=script&lang=js"
export * from "./FieldSelectorMultiple.vue?vue&type=script&lang=js"
import style0 from "./FieldSelectorMultiple.vue?vue&type=style&index=0&id=2736c876&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2736c876",
  null
  
)

export default component.exports